import { HistoryReducer } from "./history.reducer";
import { CurrentRouteReducer } from "./currentRoute.Reducer";
import { NavigationReducerFactory } from "./navigation.reducer.factory";
import { RouteConfigurationReducer } from "./routeConfiguration.reducer";
import { UpdateRouteConfigurationReducer } from './updateRouteConfiguration.reducer';
var ReducerFactory = /** @class */ (function () {
    function ReducerFactory(fxpRouteService) {
        this._navigationReducerFactory = new NavigationReducerFactory(fxpRouteService);
    }
    ReducerFactory.prototype.GetConfigurationReducer = function () {
        return RouteConfigurationReducer;
    };
    ReducerFactory.prototype.UpdateRouteConfigurationReducer = function () {
        return UpdateRouteConfigurationReducer;
    };
    ReducerFactory.prototype.GetCurrentRouteReducer = function () {
        return CurrentRouteReducer;
    };
    ReducerFactory.prototype.GetHistoryReducer = function () {
        return HistoryReducer;
    };
    ReducerFactory.prototype.GetNavigationReducer = function () {
        return this._navigationReducerFactory.BuildNavigationReducer();
    };
    return ReducerFactory;
}());
export { ReducerFactory };
//# sourceMappingURL=reducer.factory.js.map